import { useFormik } from "formik";
import React from "react";
import validationSchema from "./ValidateSchema";
import { SnackbarProvider, enqueueSnackbar } from "notistack";
import { useState } from "react";
import OTPView from "./OTPView";
import { Col, Container, Row } from "react-bootstrap";
import "./BookDemo.css";

const BookDemo = () => {
  const [otpView, setOtpView] = useState(false);
  const formik = useFormik({
    initialValues: {
      company: "",
      email: "",
      phone: "",
      name: "",
      role: "",
      requesttype: "lead",
      leadType: "Demo",
      parentid: "siapischain",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const data = JSON.stringify(values);
      try {
        const url = `${window.livasaConfig.getOtp}${window.livasaConfig.networkid}/otp/register/${window.livasaConfig.clientId}/${window.livasaConfig.clientSecret}`;
        const res = await fetch(url, {
          method: "POST",
          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
          },
          body: data,
        });

        const response = await res.text();
        if (response === "Email Already Registered.") {
          enqueueSnackbar(response, { variant: "error",autoHideDuration: 4000 });
          setOtpView(false);
        } else if (response === "Mobile Already Registered") {
          enqueueSnackbar(response, { variant: "error",autoHideDuration: 4000 });
        } 
        else if (response === "Server error: Failed to send OTP via Email") {
          enqueueSnackbar(response, { variant: "error",autoHideDuration: 4000 });
          setOtpView(false);
        } else {
          enqueueSnackbar(response, { variant: "success",autoHideDuration: 4000 });
          setOtpView(true);
        }
      } catch (error) {
        enqueueSnackbar("Submission failed. Try again later.", {
          variant: "error",
          autoHideDuration: 4000
        });
      }
    },
  });
  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      {!otpView ? (
        <>
          <Container className="demo-container">
            <Row className="justify-content-center">
              <Col md={6}>
                <form onSubmit={formik.handleSubmit}>
                  <div>
                    <label className="d-block">Company Name*</label>
                    <input
                      value={formik.values.company}
                      name="company"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.company && formik.errors.company && (
                      <div style={{ color: "red" }}>
                        {formik.errors.company}
                      </div>
                    )}
                  </div>

                  <div>
                    <label>Name*</label>
                    <input
                      value={formik.values.name}
                      name="name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.name && formik.errors.name && (
                      <div style={{ color: "red" }}>{formik.errors.name}</div>
                    )}
                  </div>

                  <div>
                    <label>Phone Number*</label>
                    <input
                      value={formik.values.phone}
                      name="phone"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.phone && formik.errors.phone && (
                      <div style={{ color: "red" }}>{formik.errors.phone}</div>
                    )}
                  </div>

                  <div>
                    <label>Email*</label>
                    <input
                      value={formik.values.email}
                      name="email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div style={{ color: "red" }}>{formik.errors.email}</div>
                    )}
                  </div>

                  <div>
                    <label>Enterprise Size*</label>
                    <select
                      value={formik.values.role}
                      name="role"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <option value="" disabled>
                        Select Size
                      </option>
                      <option value="Large">Large</option>
                      <option value="Medium">Medium</option>
                      <option value="Small">Small</option>
                      <option value="Micro">Micro</option>
                    </select>
                    {formik.touched.role && formik.errors.role && (
                      <div style={{ color: "red" }}>{formik.errors.role}</div>
                    )}
                  </div>

                  <button type="submit" className="pt-2 pb-2 px-3 rounded mt-2">
                    Submit
                  </button>
                </form>
              </Col>
            </Row>
          </Container>
        </>
      ) : (
        <Container className="demo-container">
          <Row className="justify-content-center">
            <Col md={6}>
              <OTPView data={formik.values} />
            </Col>
          </Row>
        </Container>
      )}
    </SnackbarProvider>
  );
};

export default BookDemo;
